import { IconChevronDownLarge } from '@picsart/icons';
import { useState, useRef, useEffect } from 'react';
import cls from 'classnames';

import useStyles from './faqItemStyles';
import { FaqItemProps } from './types';

function FaqItem({
  title,
  description,
  headingTag,
  descriptionTag,
  initialExpansion,
}: FaqItemProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const classes = useStyles();
  const HeadingTag = headingTag;
  const DescriptionTag = descriptionTag;
  const height = isExpanded ? ref.current?.scrollHeight || 0 : 0;
  useEffect(() => {
    setIsExpanded(initialExpansion);
  }, [initialExpansion]);
  return (
    <li className={cls(classes.root, isExpanded && classes.expanded)}>
      <div className={classes.titleContainer} onClick={() => setIsExpanded(!isExpanded)}>
        <HeadingTag className={classes.title}>{title}</HeadingTag>
        <IconChevronDownLarge className={cls(classes.icon, isExpanded && classes.iconExpanded)} />
      </div>
      <DescriptionTag
        className={cls(classes.description, isExpanded && classes.descriptionExpanded)}
        ref={ref}
        style={{ height }}
      >
        {description}
      </DescriptionTag>
    </li>
  );
}

export default FaqItem;
